var map = {
	"./ADMIN_RETURNS_PORTAL_AUSP.json": [
		92147,
		2147
	],
	"./ADMIN_RETURNS_PORTAL_BLUE_YONDER.json": [
		32524,
		2524
	],
	"./ADMIN_RETURNS_PORTAL_BPOST.json": [
		54350,
		4350
	],
	"./ADMIN_RETURNS_PORTAL_DPD_UK.json": [
		496,
		496
	],
	"./ADMIN_RETURNS_PORTAL_GLS_ES.json": [
		11492,
		1492
	],
	"./ADMIN_RETURNS_PORTAL_SINGAPORE_POST.json": [
		54312,
		4312
	],
	"./ADMIN_RETURNS_PORTAL_STARLINKS.json": [
		64057,
		4057
	],
	"./ADMIN_RETURNS_PORTAL_USPS.json": [
		46595,
		6595
	],
	"./ADMIN_RETURNS_PORTAL_VANILLA_NOT_USED.json": [
		80396,
		396
	],
	"./ADMIN_RETURNS_PORTAL_YAMATO.json": [
		6348,
		6348
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 87577;
module.exports = webpackAsyncContext;